// extracted by mini-css-extract-plugin
module.exports = {"contentKinescope":"ContentKinescope__contentKinescope__1489L","kinescopePlayer":"ContentKinescope__kinescopePlayer__3SOAy"};